import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatNumber } from '@/shared/lib/format';
import { cn } from '@/shared/lib/utils';

import { QUEUES } from '../lib/attention-queues';
import type { DashboardAttention } from '../types/dashboard.types';

/**
 * What needs someone. The backend returns null for a queue the staff member
 * may not see, and those rows are left out rather than shown as zero.
 */
export function AttentionPanel({ attention }: { attention: DashboardAttention }) {
  // `!= null`: a queue an older backend does not return at all is left out too.
  const visible = QUEUES.filter((queue) => attention[queue.key] != null);
  if (visible.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Needs attention</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="divide-y">
          {visible.map((queue) => {
            const count = attention[queue.key] ?? 0;
            return (
              <li key={queue.key}>
                <Link
                  to={queue.to}
                  className="hover:bg-muted/50 flex items-center justify-between gap-3 rounded-sm px-1 py-2 text-sm"
                >
                  <span>{queue.label}</span>
                  <span className="flex items-center gap-1">
                    <span
                      className={cn(
                        'tabular-nums',
                        count > 0 ? 'text-foreground font-semibold' : 'text-muted-foreground',
                      )}
                    >
                      {formatNumber(count)}
                    </span>
                    <ChevronRight
                      className="text-muted-foreground size-4 rtl:rotate-180"
                      aria-hidden
                    />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
